export default function Profile(){
    return <div>Index</div>
}